'use strict';

angular.module('atex.dam').factory('DamQueuesNode', function() {

  var DamQueues = {
    nodeTypes: {
      ROOT: 1,
      PROFILE: 2,
      QUEUE: 3,
      SPIKE_QUEUE: 4
    }
  };

  var DamQueuesNode = function(parentNode, id, name, owners, smartFolder, printFolder, delimiter ) {
    this.id = id;
    if (name) {
      this.name = name;
    } else {
      this.name = 'no name';
    }
    this.owners = owners;
    this.collapsed = true;
    if (parentNode) {
      this.parentNode = parentNode;
      parentNode.children = parentNode.children || (parentNode.children = []);
      parentNode.children.push(this);
    }

    this.smartFolder = smartFolder;
    this.printFolder = printFolder;
    this.delimiter = delimiter;

    if ( this.printFolder === DamQueues.nodeTypes.SPIKE_QUEUE ) {
      this.folderClosedIconClass = 'icon-spike fa fa-folder-o';
      this.folderOpenIconClass = 'icon-spike fa fa-folder-open-o';
    } else {
      this.folderClosedIconClass = this.printFolder >= DamQueues.nodeTypes.QUEUE ? 'fa fa-folder-o' : 'fa fa-folder';
      this.folderOpenIconClass = this.printFolder >= DamQueues.nodeTypes.QUEUE ? 'fa fa-folder-open-o' : 'fa fa-folder-open';
    }

    this.queuePath = this.buildPath();

    this.types = [];
  };

  DamQueuesNode.nodeTypes = DamQueues.nodeTypes;

  DamQueuesNode.prototype.buildPath = function() {
    var folders = [this.name];
    var parent = this.parentNode;
    while(parent && !parent.isRoot) {
      folders.push(parent.name);
      parent = parent.parentNode;
    }
    folders.reverse();
    return this.delimiter + folders.join(this.delimiter);
  };

  DamQueuesNode.prototype.getPhysicalParent = function() {
    if (!this.smartFolder) {
      return this;
    }
    var parent = this.parentNode;
    while(parent && !parent.isRoot) {
      if (!parent.smartFolder) {
        return parent;
      }
      parent = parent.parentNode;
    }
    return;
  };

  DamQueuesNode.prototype.setTypes = function(array) {
    this.types = array;
  };

  DamQueuesNode.prototype.getAllowedTypes = function() {
    if (!this.smartFolder) {
      return this.types;
    }
    // If smart lookup on the parents (smart and physical if exits)
    var currentTypes = angular.copy(this.types);
    var parent = this.parentNode;
    var typesAreFromPhys = false;
    while(parent && currentTypes.length<=0) {
      typesAreFromPhys = !parent.smartFolder;
      currentTypes = parent.types;
      parent = parent.parentNode;
    }
    if (!typesAreFromPhys) {
      // Check also the types from PhysicalParent
      var physParent = this.getPhysicalParent();
      if (physParent) {
        // Check both arrays....
        var physTypes = angular.copy(physParent.types);
        if (physTypes.length>0) {
          // Return physTypes that are also in the smartTypes
          for (var i = physTypes.length-1; i>=0; i--) {
            if (_.indexOf(currentTypes, physTypes[i]) === -1) {
              physTypes.splice(i, 1);
            }
          }
          currentTypes = physTypes;
        }
      }
    }
    return angular.copy(currentTypes);
  };

  return DamQueuesNode;
});

angular.module('atex.dam').service('DamQueuesService', ['$q', '$rootScope', '$injector', '$timeout',
  'DamQueuesNode', 'DamService',
  'DamSearchService', 'ContentService', 'SearchService', 'AssignService', '$translate', 'DamNotificationService',
  'DamActivityService', 'configuration','DamLocalizationService', 'ApplicationConfigurationService',
  function($q, $rootScope, $injector, $timeout,
           DamQueuesNode, DamService,
           DamSearchService, ContentService, SearchService, AssignService, $translate, DamNotificationService,
           DamActivityService, configuration, DamLocalizationService, ApplicationConfigurationService) {


    var self = this;
    var initInProgress = false;

    // keep model for DamFoldersController
    self.rootNode = {};
    self.hideRoot = true;
    self.treemodel = [];
    self.selectedNode = {};
    self.userInfo = {};
    // keep also a separated model for DamMoveToFolderModalController
    self.moveRootNode = {};
    self.moveTreemodel = [];
    self.moveSelectedNode = {};
    self.PrintService = undefined;
    self.printSystem =  undefined;
    self.ADMUtils = undefined;
    self.folderDelimiter = '';

    self.listingFolder = undefined;

    var _escape = function(toescape) {
      var value = DamService.escapeLucene(toescape);
      return value.replace(new RegExp(' ', 'g'), '\\ ');
    };

    // Modify
    self.resetTree = function()  {
      this.selectedNode = undefined;
      self.treemodel.length = 0;
      self.moveSelectedNode = undefined;
      self.moveTreemodel.length = 0;
    };

    self.setUserInfo = function(userInfo) {
      self.userInfo = userInfo;
    };

    self.resetValues = function() {
      self.userInfo = undefined;
      if (self.rootNode) {
        self.rootNode.collapsed = true;
        if (self.rootNode.children) {
          self.rootNode.children.length = 0;
        }
      }
      self.resetTree();
    };

    self.getMaxFolders = function() {
      return ApplicationConfigurationService.getConfigurationFor([ 'maxSubFoldersSize' ]).then(function(data) {
        return data || 100;
      });
    };

    self.searchSubFolders = function(folderId) {
      return DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
        self.setUserInfo(currentUserInfo);
        return self.getMaxFolders().then(function (maxRows) {
          return DamService.getSolrServerInfo().then(function(solrInfo) {
            return _.extend({maxRows: maxRows}, solrInfo);
          });
        });
      }).then(function(solrInfo) {
        var transferInfo = {};
        transferInfo['variant'] = 'list';
        transferInfo['fl'] = 'id';
        // AMS-6252 - let the max number of results being configurable.
        transferInfo['rows'] = solrInfo.maxRows;
        transferInfo['core'] = solrInfo.solrCore;
        transferInfo['q'] = '+atex_desk_objectType:(folder)';
        transferInfo['q'] += '+parent_atex_desk_ss:(' + _escape(folderId) + ')';
        if (!self.userInfo.isAdm) {
          transferInfo['q'] += '+assignees_atex_desk_sms:(';
          transferInfo['q'] += self.userInfo.externalId;
          for (var i=0; self.userInfo.groups && i<self.userInfo.groups.length;i++) {
            var escaped = self.userInfo.groups[i].principalId.replace(':', '\\:');
            transferInfo['q'] += ' OR ' + escaped;
          }
          transferInfo['q'] += ')';
        }
        transferInfo['sort'] = "name_atex_desk_ss asc";
        return SearchService.search(transferInfo);
      });
    };

    self.expandNode = function(node) {
      if (node.children) {
        node.children.length = 0;
      }
      return self.searchSubFolders(node.id).then(function(response) {
        // AMS-6252
        // if there are more results (numFound) that the searched ones we should emit a warning
        // in the console to let the user know there are more folders than the limit we have.
        self.getMaxFolders().then(function(maxRows) {
          if ((response.data.response.numFound || 0) > maxRows) {
            console.warn('We found ' + response.data.response.numFound +
              ' folders which are more than the configured \'maxSubFoldersSize\' (' + maxRows +
              ') to be displayed');
          }
        });
        response.data.response.docs.map(function(doc) {
          var assignees = doc._data.aspects['atex.dam.standard.ContentAccess'].data.assignees;
          var owners = AssignService.getOwnersFromAssignees(assignees);
          var folderName = doc._data.aspects.contentData.data.name;
          var smartFolder = doc._data.aspects.contentData.data.smartFolder;
          var printFolder = doc._data.aspects.contentData.data.printFolder;
          var childNode = new DamQueuesNode(node, doc.id, folderName, owners, smartFolder, printFolder, self.folderDelimiter );

          var values = atex.dam.AngularUtils.getTypeValues(doc, "_data/aspects/contentData/data/fields") || [];
          childNode.setTypes(values);
        });
      });
    };

    self.initializeTree = function(reset) {
      if ( initInProgress || !(self.printSystem && self.printSystem.loadQueues) ) {
        return;
      }
      initInProgress = true;
      if (reset) {
        self.resetValues();
      }
      var deferred = $q.defer();
      DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
        self.setUserInfo(currentUserInfo);
        return ContentService.getContent({id: 'externalid/RootPrintFolder'});
      }). then (function(response) {
        self.resetTree();
        var assignees = response.data.aspects['atex.dam.standard.ContentAccess'] ? response.data.aspects['atex.dam.standard.ContentAccess'].data.assignees : undefined;
        var smartFolder = response.data.aspects.contentData.data.smartFolder;
        var printFolder = response.data.aspects.contentData.data.printFolder;
        var owners = AssignService.getOwnersFromAssignees(assignees);
        var folderName = response.data.aspects.contentData.data.name;
        self.folderDelimiter = _.isEmpty(folderName) ? "/" : folderName[0];

        var rootNode = new DamQueuesNode(null, response.id, folderName, owners, smartFolder, printFolder, self.folderDelimiter );

        rootNode.collapsed = true;
        rootNode.isRoot = true;
        self.rootNode = angular.copy(rootNode);
        self.moveRootNode = angular.copy(rootNode);
        // Check if the current user can see the root folder
        //var canSee = self.userInfo.isAdm || AssignService.canUserSeeTheFolder(self.userInfo.externalId, self.userInfo.groups, assignees);
        var canSee = false;
        self.hideRoot = !canSee;
        self.treemodel.push(self.rootNode);
        self.moveTreemodel.push(self.moveRootNode);
        if (self.hideRoot) {
          self.rootNode.collapsed = false;
          self.moveRootNode.collapsed = false;
          self.expandNode(self.rootNode).then(function(response) {
            self.expandNode(self.moveRootNode).then(function(response) {
              deferred.resolve();
            });
          });
        } else {
          deferred.resolve(self.rootNode);
        }
      }).then(null, function(error) {
        DamLocalizationService.translate("__FOLDERS_INIT_ROOT_ERROR_MSG__").then (function (message) {
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        });
        deferred.reject(error);
      }).finally(function(){
        initInProgress = false;
      });
      return deferred.promise;
    };

    self.canDragTypesFromDragUrl = function (dragUrl) {
      var canDrop = true;
      var urlparts = dragUrl.split('&');

      angular.forEach(urlparts, function (part) {
        var map = part.split("=");
        if (map[0] === 'contentlist') {
          var objs = JSON.parse(map[1]);
          angular.forEach(objs, function (obj) {

            if (obj.type !== 'image' && obj.type !== 'photo' &&
              obj.type !== 'article' && obj.type !== 'text' &&
              obj.type !== 'page') {
              canDrop = false;
            }
          });
        }
      });
      return canDrop;
    };

    self.reportError = function( type, message ) {
      if ( !self.ADMUtils ) {
        self.ADMUtils = $injector.get("ADMUtils");
      }
      var msg = self.ADMUtils.translate(message);
      var shouldLog = type === 'success';

      DamNotificationService.addNotification(atex.dam.Notification({ type: type, message: msg }), shouldLog);
    };

    self.addContentToFolder = function(dragUrl, ids, node, copy) {
      var deferred = $q.defer();
      var idsLen = ids.length;
      var countNotMatch = 0;
      var countAlreadyIn = 0;
      var locked = false;
      var noPromises = [];

      if ( !self.ADMUtils ) {
        self.ADMUtils = $injector.get("ADMUtils");
      }

      if ( !self.PrintService ) {
        self.PrintService = $injector.get("PrintService");
      }

      var canDrop = self.canDragTypesFromDragUrl(dragUrl);

      if ( !canDrop || !node.printFolder || node.printFolder < DamQueuesNode.nodeTypes.QUEUE ) {
        self.reportError( 'error', '__PRINT_QUEUES_FAILED_WRONG_TYPE__' );
        return $q.all(noPromises);
      }

      var queuePath = node.buildPath();
      var contentOptions = {
        contentId: ids[0],
        layoutOptions: {},
        subType: 'sendToQueue',
        contentData: {
          copy: !!copy,
          ids: ids,
          dragUrl: dragUrl,
          queue: queuePath
        }
      };

      self.PrintService.content(contentOptions).then(function (data) {
        if ( !data.errorReported ) {
          self.reportError( 'success', '__OPERATION_COMPLETED_SUCCESSFULLY__' );
        }

        $timeout( function() {
          ids.forEach( function(id) { $rootScope.$broadcast('dam:updatedItem', {id: id }); });
        }, 2000 );

        deferred.resolve();
      }).catch(function (error) {
        var message = self.ADMUtils.translate('__GENERIC_ERROR_MSG__') + ': ' + error;
        self.reportError( 'error', message );
        deferred.reject( error );
      });

      return deferred.promise;
    };

    var _calcolateFilterQuery = function(advanced) {
      if (typeof(advanced) !== "object") {
        return $q.when();
      }
      var query2Execute = angular.copy(advanced);
      query2Execute._type = "atex.dam.standard.Query";

      var fullTextField = _.find(query2Execute.fields, function(field) {
        return field.key === 'atex_desk_text';
      });
      if (fullTextField && fullTextField.values[0]) {
        // Temporary add 'AND' between terms in  atex_desk_text
        fullTextField.values[0] = DamService.normalizeQueryString(fullTextField.values[0]);
      }
      var queryContainer = {
        'container' : {
          'aspects' : {
            'contentData' : {
              'data' : query2Execute
            }
          }
        }
      };
      return DamService.getQuery(queryContainer.container).then(function(queryData) {
        return queryData.data.solr_query;
      });
    };

    /**
     * 'fullText' can be undefined or can be a simple string (real fullText search) or can be the advanced search model
     * in case it's the advanced we calculate a fq from the model and pass it as a filter query
     */
    self.executeQuery = function(folderNode, fullText) {
      var ts = Date.now();
      DamSearchService.setLastQueryStartTs(ts);
      ContentService.getContent({id: folderNode.id}).then(function(folder) {
        if (!DamSearchService.isStillLastQuery(ts)) {
          return $q.reject();
        }
        var isSmartFolder = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/contentData/data/smartFolder').value;
        var printFolder = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/contentData/data/printFolder').value;
        var isDynamic = fullText && fullText.isDynamic ? fullText.isDynamic : atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/contentData/data/isDynamic').value;
        //clear button removes isDynamic property - in that case use the value displayed in adv search popup (false)
        if (typeof(fullText) === "object" && fullText.isDynamic === undefined) {
          isDynamic = false;
        }

        var query = {};
        query._type = "atex.dam.standard.Query";
        query.hiddenQuery = true;

        var types = folderNode.getAllowedTypes();
        if (!types || types.length <= 0) {
          types = DamService.getAllDeskObjType().split(" ");
        }

        atex.dam.AngularUtils.addTypeField(types, folder, "data/aspects/contentData/data/fields");

        query.includeTrash = folder.data.aspects.contentData.data.includeTrash;
        query.viewMode = folder.data.aspects.contentData.data.viewMode;

        query.metadataQuery = "";
        query.isDynamic = isDynamic;

        // Set order
        var storedSortValue = folder.data.aspects.contentData.data.sortValue;
        var storedSortOrderValue = folder.data.aspects.contentData.data.sortOrderValue;
        query.sortValue = storedSortValue ? storedSortValue : $rootScope.damSortData.currentSortValue;
        query.sortOrderValue = storedSortOrderValue ? storedSortOrderValue : $rootScope.damSortData.currentSortOrderValue;

        var fields =  folder.data.aspects.contentData.data.fields;
        if (!fields) {
          fields = [];
        }
        var filterProductionField = {
          key: "tag_dimension.partition_ss",
          values: ["production"],
          type: "STRING",
          subQuery: false
        };
        fields.push(filterProductionField);
        query.fields = fields;

        folder.queryTs = ts;

        if (fullText) {
          folder.refiningFolderSearch = true;
          folder.fullText = fullText;
          if (typeof(fullText) !== "object") {
            query.fullText = fullText;
          } else {
            query.fullText = fullText.fullText;
          }
        } else {
          // Set fullText
          var _fullTxt = folder.data.aspects.contentData.data.fullText;
          if (_fullTxt) {
            query.fullText = _fullTxt;
          }
        }

        _calcolateFilterQuery(fullText).then(function(fq){
          if (!folder.refiningFolderSearch) {
            var currAdvQuery = DamSearchService.getCurrentAdvQuery();
            Object.keys(currAdvQuery).forEach(function(key) { delete currAdvQuery[key]; });
          }
          folder.advancedAsFolderFilter = fq;
          DamSearchService.advancedSearch(query, folder);
        });
      });
    };

    //Handle login / logout
    $rootScope.$on("dam:logout", function() {
      self.resetValues();
    });
    $rootScope.$on("onecms:authenticationSuccess", function() {
      self.initializeTree(true);
    });

    self.findNode = function( currNode, queuePath ) {
      if (currNode.queuePath === queuePath) {
        return currNode;
      } else if (currNode.children && currNode.children.length) {
        for (var i = 0; i < currNode.children.length; i++) {
          if (currNode.children[i].queuePath === queuePath) {
            return currNode.children[i];
          } else {
            var node = self.findNode(currNode.children[i], queuePath);

            if ( node ) {
              return node;
            }
          }
        }
      }
      return null;
    };

    $rootScope.$on('dam:selectQueue', function( event, value ) {
      if ( self.listingFolder ) {
        self.executeQuery( self.listingFolder );
      }
    });

    self.resetSelection = function(dontClearAdvanced) {
      if (self.resettingSelection) {
        return;
      }
      self.resettingSelection = true;
      self.listingFolder = undefined;
      if (!dontClearAdvanced) {
        $rootScope.$broadcast("dam:clearFolderInfo");
      }
      self.resettingSelection = false;
    };

    var printSystemPromise = ApplicationConfigurationService.getConfigurationFor(['printSystem']);

    $q.all([printSystemPromise]).then(function(result) {
      self.printSystem = result[0];
      self.initializeTree();
    });
  }]);


